/**
 * Response from Authorization Server On Success/ Failure
 */
export interface OAuthResponse {
  error?: string;
  errorDescription?: string;
  errorUri?: string;
  accessToken?: string;
  tokenExpiresInSeconds?: number;
  tokenType?: string;
}

export const OAuthResponseConstants = {
  ACCESS_TOKEN: 'access_token',
  EXPIRES_IN: 'expires_in',
  TOKEN_TYPE: 'token_type',
  SCOPE: 'scope',
  ERROR: 'error',
  ERROR_DESCRIPTION: 'error_description',
  ERROR_URI: 'error_uri',
  /**
   * The client doesn't pass a proper Authorization Token
   */
  UNAUTHORIZED_CLIENT: 'unauthorized_client',

  UNSUPPORTED_GRANT_TYPE: 'unsupported_grant_type',
  /**
   * One or more Of the parameters passed to Authorization Endpoint is invalid
   */
  INVALID_REQUEST: 'invalid_request',

  INVALID_CLIENT: 'invalid_client',

  /**
   * If the provided permission ticket was not found at the authorization server,
   * or the provided permission ticket has expired
   */
  INVALID_GRANT: 'invalid_grant',
  INVALID_SCOPE: 'invalid_scope',
  UNKNOWN_ERROR: 'unknown_error',
};
